import api from '@/services/Api';

class CategoryService {
  async getCategoryListByManufacturerId(manufacturerId) {
    const response = await api.get('/distributor/category/all-by-manufacturer-id/' + manufacturerId)
    return response.data
  }
}

export default new CategoryService()
